import { Box, Button, Card, Typography } from "@mui/material";
import FriendsConnection from "./FriendsConnection";
import { useNavigate } from "react-router-dom";

const InterestGroups = ({ title, items }) => {
  const navigate = useNavigate(); // Move hook inside component

  return (
    <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="subtitle2" fontWeight={600}>
          {title}
        </Typography>
        <Button 
          onClick={() => navigate('/groups-page')} 
          size="small" 
          sx={{ textTransform: 'none', fontSize: 12 }}
        >
          View All
        </Button>
      </Box>
      {items.map((item, index) => (
        <FriendsConnection key={index} {...item} />
      ))}
    </Card>
  );
};

export default InterestGroups;